import React, { useState } from 'react';
import Popper from '@mui/material/Popper';
import { ClickAwayListener, Dialog, DialogContent, DialogTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useWindowSize } from '../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../utils/constants';
import styles from './InfoSign.module.scss';
import colors from '../../../scss/colors';

export default function InfoSign(props) {
  const { icon, children, text } = props;

  const size = useWindowSize();

  const [anchorEl, setAnchorEl] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? false : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  return (
    <>
      <div aria-describedby={id} role="presentation" onClick={handleClick}>
        {icon}
        <span className={styles.name}>{text}</span>
      </div>
      {anchorEl && size.width > responsiveSizeTimesheet ? (
        <ClickAwayListener onClickAway={handleClick}>
          <Popper
            id={id}
            open={!!open}
            anchorEl={anchorEl}
            placement="bottom-start"
            modifiers={[
              {
                name: 'offset',
                options: {
                  offset: [0, 18]
                }
              }
            ]}
          >
            {children}
          </Popper>
        </ClickAwayListener>
      ) : (
        <Dialog
          onClose={() => setAnchorEl(null)}
          open={!!anchorEl}
          sx={{
            '& .MuiPaper-root.MuiDialog-paper': {
              width: 'calc(100% - 24px)',
              maxWidth: '100%',
              margin: '16px'
            },
            '& .MuiDialog-paper': {
              borderRadius: '20px',
              overflowY: 'visible',
              paddingBottom: '16px',
              backgroundColor: colors.PAGE_BACKGROUND
            }
          }}
        >
          <DialogTitle>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-end',
                marginRight: '-6px'
              }}
              role="presentation"
              onClick={() => setAnchorEl(null)}
              data-testid="mobiledialog"
            >
              <CloseIcon sx={{ color: colors.ICON_GREY }} />
            </div>
          </DialogTitle>
          <DialogContent
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              justifySelf: 'center',
              alignSelf: 'center'
            }}
          >
            {children}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
